import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Pill } from 'ui-components/components/pill';
import Global from '../../../store/global-selectors';
import style from './tags-column.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const TagsColumn = ({ tagIds = emptyArray }) => {
  const allTags = useSelector(Global.selectSellerTags);
  const tags = allTags.filter((tag) => tagIds.find((id) => tag.tagId === id));

  return (
    <div className={style['pill-list']}>
      {tags.map((tag) => (
        <Pill key={tag.tagId} className={style.pill} collapsed color={tag.hexColor} label={tag.name} theme='tag' />
      ))}
    </div>
  );
};

TagsColumn.propTypes = {
  tagIds: PropTypes.arrayOf(PropTypes.string),
};

export default memo(TagsColumn);
